import { render, staticRenderFns } from "./AppScroller.vue?vue&type=template&id=2c1d5262&scoped=true&"
import script from "./AppScroller.vue?vue&type=script&lang=js&"
export * from "./AppScroller.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c1d5262",
  null
  
)

export default component.exports